import { useTheme } from "next-themes";

import FlickeringGrid from "@/components/magicui/flickeringGrid";
import { PricingCardsAlt } from "@/components/pricing/pricing-cards-alt";
import { HeaderSection } from "@/components/shared/header-section";
import MaxWidthWrapper from "@/components/shared/max-width-wrapper";
import * as m from "@/paraglide/messages";

import { Faq } from "./section-faq";

export default function PricingSection() {
  const { theme } = useTheme();
  return (
    <section id="pricing" className="relative">
      <FlickeringGrid
        className="[mask-image:radial-gradient(ellipse_at_center,white,transparent,transparent)] z-0 absolute  inset-0 size-full"
        squareSize={2}
        gridGap={8}
        color={theme === "light" ? "#6B7280" : "#fff"}
        maxOpacity={0.4}
        flickerChance={0.3}
      />
      <MaxWidthWrapper>
        <div className="flex flex-col items-center text-center">
          <HeaderSection
            label={m.Pricing()}
            title={m.polite_house_platypus_ascend()}
          />
          <PricingCardsAlt />
          <p className="mt-3 text-balance text-center text-base text-muted-foreground">
            Email{" "}
            <a
              className="font-medium text-primary hover:underline"
              href="mailto:contact@arya.com"
            >
              contact@arya.com
            </a>{" "}
            {m.brave_kind_kitten_fetch()}
            <br />
          </p>
        </div>
      </MaxWidthWrapper>
      <div className="py-8">
        <Faq />
      </div>
    </section>

    /* <section id="pricing" className="relative">
      <FlickeringGrid
        className="[mask-image:radial-gradient(ellipse_at_center,white,transparent,transparent)] z-0 absolute  inset-0 size-full"
        squareSize={2}
        gridGap={8}
        color={theme === "light" ? "#6B7280" : "#fff"}
        maxOpacity={0.6}
        flickerChance={0.3}
      />
      <MaxWidthWrapper>
        <div className="flex flex-col items-center text-center">
          <div className="bg-black p-4 rounded">
            <TimerBf />
          </div>
          <h1
            className="text-primary text-center dark:from-white dark:to-white/40 animate-fade-up  opacity-0 text-4xl font-extrabold tracking-tight !leading-tight sm:text-4xl md:text-4xl lg:text-7xl  text-balance bg-gradient-to-br from-black from-30% to-black/60 bg-clip-text"
            style={{ animationDelay: "0.25s", animationFillMode: "forwards" }}
          >
            BLACK FRIDAY DEAL{" "}
          </h1>
          <h2
            className="text-transparent text-center dark:from-white dark:to-white/40 animate-fade-up  opacity-0 text-4xl font-extrabold tracking-tight !leading-tight sm:text-4xl md:text-4xl lg:text-7xl lg:pb-4 text-balance bg-gradient-to-br from-black from-30% to-black/60 bg-clip-text"
            style={{ animationDelay: "0.25s", animationFillMode: "forwards" }}
          >
            <span className="bg-black text-white  px-2">UP TO 50% OFF</span>
          </h2>

          <PricingCardsBF />
          <p className="mt-3 text-balance text-center text-base text-muted-foreground">
            Email{" "}
            <a
              className="font-medium text-primary hover:underline"
              href="mailto:contact@arya.com"
            >
              contact@arya.com
            </a>{" "}
            {m.brave_kind_kitten_fetch()}
            <br />
          </p>
        </div>
      </MaxWidthWrapper>
      <div className="py-8">
        <Faq />
      </div>
    </section> */
  );
}
